import { useTranslation } from "react-i18next";
import { UseFormReturn } from "react-hook-form";

import { TransportationAttribute } from "@/data/models/transportation-attribute.model";

import {
  ReservationFormInput,
  ReservationFormValues,
} from "../schema/reservationForm.schema";

import Checkbox from '@/components/forms/Checkbox';
import { AlternateContact } from "./AlternateContact";
import { AdditionalPassengers } from "./AdditionalPassengers";
import { RequestedProvider } from "./RequestedProvider";
import { AdditionalAttributes } from "./AdditionalAttributes";

type MemberFormOtherInputsProps = {
  form: UseFormReturn<ReservationFormInput, unknown, ReservationFormValues>;
  transportationAttributes: TransportationAttribute[];
}

const MemberFormOtherInputs = ({
  form,
  transportationAttributes,
}: MemberFormOtherInputsProps) => {
  const { t } = useTranslation('common');

  const showOtherInputs = form.watch('ShowOtherInputs');

  return (
    <>
      <Checkbox
        name="ShowOtherInputs"
        label={t('reservation.otherInputs')}
        control={form.control as any}
      />
      {showOtherInputs && (
        <>
          <AlternateContact form={form} />
          <AdditionalPassengers form={form} transportationAttributes={transportationAttributes} />
          <AdditionalAttributes form={form} transportationAttributes={transportationAttributes} />
          <RequestedProvider form={form} />
        </>
      )}
    </>
  );
}

export { MemberFormOtherInputs };